document.addEventListener('DOMContentLoaded', initCancelOrderFormHandler);

async function requestOrderCancellation(orderName, orderEmail, defaultErrorMessage) {
    const body = {
        orderName: orderName,
        orderEmail: orderEmail
    };

    const response = await fetch('/apps/api/orders/status/manual-cancel', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    });

    const contentType = response.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
        throw new Error(defaultErrorMessage);
    }

    const responseJson = await response.json();

    if (!response.ok || !responseJson.success) {
        throw new Error(responseJson.message || defaultErrorMessage);
    }

    return responseJson;
}

function initCancelOrderFormHandler() {
    const cancelOrderForm = document.getElementById('cancel-order-form');
    const successMessage = document.getElementById('cancel-order-success-message');
    const successText = successMessage?.querySelector('p.note.form-success');
    const errorMessage = document.getElementById('cancel-order-error-message');
    const errorText = errorMessage?.querySelector('p.note.form-error');
    const submitButton = document.getElementById('cancel-order-submit-button');

    if (!cancelOrderForm || !submitButton) {
        return;
    }

    cancelOrderForm.addEventListener('submit', async (event) => {
        event.preventDefault();

        const defaultErrorMessage = cancelOrderForm.dataset.errorMessage || 'Error';
        const successMessageText = cancelOrderForm.dataset.successMessage || 'Success';

        const spinner = submitButton.querySelector('.spinner');
        spinner?.classList.remove('hidden');
        submitButton.disabled = true;
        submitButton.classList.add('loading');

        successMessage?.classList.add('hidden');
        errorMessage?.classList.add('hidden');

        const formData = new FormData(cancelOrderForm);
        const orderEmail = formData.get('email');
        const orderName = formData.get('order_number');

        try {
            await requestOrderCancellation(orderName, orderEmail, defaultErrorMessage);

            if (successText) {
                successText.textContent = successMessageText;
            }
            successMessage?.classList.remove('hidden');
        } catch (error) {
            if (errorText) {
                errorText.textContent = defaultErrorMessage;
            }
            errorMessage?.classList.remove('hidden');
        } finally {
            spinner?.classList.add('hidden');
            submitButton.disabled = false;
            submitButton.classList.remove('loading');
        }
    });
}
